import Vue from 'vue'
import App from './App'
import router from './router'

import iview from 'iview'
import '../node_modules/iview/dist/styles/iview.css'
import './common/css/reset.css'
import './common/css/base.styl'
import './common/css/resetIview.styl'
import {getCookie, home} from './common/js/cookie'

Vue.config.productionTip = false

Vue.use(iview)

router.beforeEach((to, from, next) => {
  let isLogin = getCookie('abc')
  console.log('to.path', to.path)
  if (!isLogin) { // 没有登录
    window.location.href = home
  } else { // 已经登录
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js